import { Navigate, useNavigate } from 'react-router-dom'
import { Row } from 'rsuite'
import { Button, Loader } from 'shared'
import useAuth from '../../hooks/Auth'
import GoogleLogo from '../../assets/images/google.svg'
import Myimg from '../../assets/images/login-logo.jpg'
import HeaderLogo from '../../assets/images/header-logo.svg'
import './login.scss'

function LoginPage() {
  const { login, loading, user, role } = useAuth()
  const navigate = useNavigate()

  if (loading) {
    return <Loader />
  }

  if (user) {
    return <Navigate to={role === 'user' ? '/user' : '/'} />
  }

  const handleLogin = async () => {
    try {
      await login()
      navigate('/')
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Login failed:', error)
    }
  }

  return (
    <div className="login_page">
      <Row>
        <div className="left_side">
          <img src={Myimg} className="networkLogo__logo" alt="Network Logo" />
        </div>
        <div className="right_side">
          <div className="innner_box">
            <h1>Welcome</h1>
            <span>to</span>
            <img
              src={HeaderLogo}
              className="agrobeet_logo"
              alt="Agrobeet Logo"
            />
            <Button onClick={handleLogin} disabled={loading}>
              {loading ? 'Logging in...' : 'Login with '}
              <img src={GoogleLogo} className="google_logo" alt="Google Logo" />
            </Button>
          </div>
        </div>
      </Row>
    </div>
  )
}

export default LoginPage
